<template>
  <div class="app-container">
    <div class="flex justify-between items-center mb-4">
      <el-form ref="queryForm"
               :model="queryParams"
               :inline="true"
               label-width="80px">
        <el-form-item label="菜谱选择" prop="menuId">
          <el-select v-model="queryParams.menuId"
                     placeholder="请选择菜谱"
                     size="small"
                     clearable>
            <el-option v-for="menu in menuList"
                      :key="menu.id"
                      :label="menu.menuName"
                      :value="menu.id" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     :loading="loading"
                     size="mini"
                     @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    
    <div class="gap"></div>
    
    <el-table v-loading="loading"
              :data="list">
      <el-table-column label="姓名" align="center" prop="name" />
      <el-table-column label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.gender === '1' ? '男' : '女' }}
        </template>
      </el-table-column>
      <el-table-column label="联系电话" align="center" prop="phone" />
      <el-table-column label="报名时间" align="center" prop="enrollTime" />
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === '1' ? 'success' : 'warning'">
            {{ scope.row.status === '1' ? '已确认' : '待确认' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    
    <el-pagination
      v-show="total>0"
      :total="total"
      @current-change="getList"
      @prev-click='getList'
      @next-click="getList"
    />
  </div>
</template>

<script>
import { getMenuList } from '../api/menu/index'
import { getEnrollList } from '../api/enroll/index'

export default {
  name: 'EnrollDetail',
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      loading: false,
      list: [],
      total: 0,
      menuList: [],
      queryParams: {
        menuId: ''
      },
      userInfo: null
    }
  },
  created () {
    // 获取当前登录用户信息
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    // 获取菜谱列表
    this.getMenuOptions()
  },
  methods: {
    // 获取菜谱列表选项
    getMenuOptions () {
      let data = {
        companyCode: this.userInfo.companyCode || '',
        pageSize: 100 // 假设最多100个菜谱
      }
      getMenuList(data).then(res => {
        if (res.code === '200') {
          this.menuList = res.data
        }
      })
    },
    
    // 查询按钮
    handleQuery () {
      this.pageIndex = 1
      this.getList()
    },
    
    // 获取报名人员列表
    getList (e) {
      if (e) {
        this.pageIndex = e
      }
      
      let data = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        menuId: this.queryParams.menuId,
        companyCode: this.userInfo.companyCode || ''
      }
      
      this.loading = true
      getEnrollList(data).then(res => {
        this.loading = false
        if (res.code === '200') {
          this.list = res.data
          this.total = res.total
        } else {
          this.$message.error('获取数据失败')
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('网络错误')
      })
    },
    
    // 重置查询
    resetQuery () {
      this.queryParams = {
        menuId: ''
      }
      this.handleQuery()
    }
  }
}
</script>

<style scoped>
.gap {
  margin: 30px 10px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.mb-4 {
  margin-bottom: 16px;
}
</style>


// WEBPACK FOOTER //
// src/enrollDetail/index.vue